export const leaveCommunityErrorsSelector = state => state.leaveCommunity.get('leaveCommunityErrors');
